// extracted by mini-css-extract-plugin
export var appear = "styles-module--appear--4d9d6";
export var appearDown = "styles-module--appear-down--e08e8";
export var appearLeft = "styles-module--appear-left--36e23";
export var appearRight = "styles-module--appear-right--4cf92";
export var appearUp = "styles-module--appear-up--fc117";
export var container = "styles-module--container--3f86b";
export var desktop = "1340px";
export var giant = "2200px";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var mobile = "400px";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var tablet = "768px";